import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { LicenceResponse, ListResponse } from '@shared/schemas';

import { initialState, type ListMutationKind, NO_MUTATION } from './lists.state';

/**
 * List Index slice. Reducers are pure state transitions only; the fetch and the
 * three management actions live in the saga, which dispatches these transitions
 * as it progresses.
 */
const slice = createSlice({
  name: 'lists',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadSucceeded: (state, action: PayloadAction<ListResponse[]>) => {
      state.rows = action.payload;
      state.loading = false;
    },
    loadFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    licencesLoadStarted: (state) => {
      state.licencesLoading = true;
    },
    licencesLoaded: (state, action: PayloadAction<LicenceResponse[]>) => {
      state.licences = action.payload;
      state.licencesLoading = false;
    },

    mutationStarted: (state, action: PayloadAction<{ kind: ListMutationKind; name: string }>) => {
      state.mutation = {
        status: 'pending',
        kind: action.payload.kind,
        name: action.payload.name,
        error: null,
      };
    },
    mutationSucceeded: (state) => {
      state.mutation.status = 'succeeded';
    },
    mutationFailed: (state, action: PayloadAction<string>) => {
      state.mutation.status = 'failed';
      state.mutation.error = action.payload;
    },
    /** The page's acknowledgement that it has shown the outcome. */
    mutationCleared: (state) => {
      state.mutation = NO_MUTATION;
    },
  },
});

export const listsActions = slice.actions;
export const listsReducer = slice.reducer;
